export default __webpack_public_path__ + "static/media/LufgaBold.0b819e40.ttf";